import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { CoreService, DialogService, DspxCardSetBaseFormComponent, SpinnerService } from 'dspx-core';
import { API_ENDPOINTS, API_ENDPOINT_KEYS } from '../../constants/api-endpoints.constants';
import { ROUTE_CONSTANTS } from '../../constants/route.constants';
import { TEMPLATES } from '../../constants/templates.constants';
import { AppDataService } from '../../services/app-data.service';
import { ResponseParserService } from '../../services/response-parser.service';
import { BaseCardSetListComponent } from '../base-card-set-list-component/base-card-set-list.component';

@Component({
  selector: 'app-care-allowance-year-list',
  templateUrl: './care-allowance-year-list.component.html',
  styleUrl: './care-allowance-year-list.component.scss'
})
export class CareAllowanceYearListComponent extends BaseCardSetListComponent implements OnInit {
  @ViewChild(DspxCardSetBaseFormComponent)
  private set _baseForm(value: DspxCardSetBaseFormComponent) {
    this.baseForm = value
  }

  private isFinancialYearType = false;

  constructor(
    protected router: Router,
    protected spinnerService: SpinnerService,
    protected dialogService: DialogService,
    protected responseParserService: ResponseParserService,
    protected appDataService: AppDataService,
    private coreService: CoreService
  ) {
    super(
      router,
      spinnerService,
      dialogService,
      responseParserService,
      appDataService,
      TEMPLATES.careAllowanceYearList,
      () => API_ENDPOINTS.dashboard.getCareAllowanceFinancialYears,
      false);
  }

  ngOnInit(): void {
    if (this.router.url.includes(ROUTE_CONSTANTS.careAllowanceFinancialYear.list)) {
      this.formServiceEndpoint = API_ENDPOINT_KEYS.getCareAllowanceFinancialYearListConfig;
      this.getListApiEndpoint = () => API_ENDPOINTS.dashboard.getCareAllowanceFinancialYears;
      this.isFinancialYearType = true;
    }
    else {
      this.formServiceEndpoint = API_ENDPOINT_KEYS.getCareAllowanceCalendarYearListConfig;
      this.getListApiEndpoint = () => API_ENDPOINTS.dashboard.getCareAllowanceCalendarYears;
    }
  }

  formLoad(event: any): void {
    this.loadGridDataOnFormLoad();
  }

  filterData(event: any): void {
  }

  actionButton_yearGrid_datagrid_new_Clicked(event: any): void {
    if (this.isFinancialYearType) {
      this.router.navigate(['/', ROUTE_CONSTANTS.careAllowanceFinancialYear.prefix]);
    }
    else {
      this.router.navigate(['/', ROUTE_CONSTANTS.careAllowanceCalendarYear.prefix]);
    }
  }

  actionButton_yearGrid_datagrid_edit_Clicked(event: any): void {
    if (this.isFinancialYearType) {
      this.router.navigate(['/', ROUTE_CONSTANTS.careAllowanceFinancialYear.prefix, event.event.data.id]);
    }
    else {
      this.router.navigate(['/', ROUTE_CONSTANTS.careAllowanceCalendarYear.prefix, event.event.data.id]);
    }
  }

  dialogSubmitted(event: any): void {
    // No dialog buttons are implemented in this dashboard
  }
}
